
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { UserModel } from '@/models/user.model';

@Component({})
export default class ChallengerDetailCommunityUser extends Vue {
  @Prop({ required: true }) user!: UserModel;

  openPublicProfile() {
    if (this.user?.slug) {
      const blankPage = this.$router.resolve({
        name: 'ProfileAbout',
        params: {
          slug: this.user.slug
        }
      });
      window.open(blankPage.href, '_blank');
    }
  }
}
